import React from 'react';
import PropTypes from 'prop-types';

import { List } from 'semantic-ui-react';

const PolicyListAddItem = ({onClick}) => {
    return (
        <List.Item id="policyAddBtn" onClick={onClick}>
            <List.Icon name="add square" size="large" verticalAlign="middle" />
            <List.Content verticalAlign="middle">
                <List.Header as="a">Add Policy</List.Header>
            </List.Content>
        </List.Item>
    );
};

PolicyListAddItem.propTypes = {
    onClick: PropTypes.func,
};

export default PolicyListAddItem;